/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

import { Card, Grid } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

import BasicMenu from "customComponents/BasicMenu";

import { formatDate } from "../../../../utils";

const periodOptions = [
  { label: "Default", value: "CURRENT_DAY" },
  { label: "Today", value: "TODAY" },
  { label: "Current Month", value: "CURRENT_MONTH" },
  { label: "Previous Month", value: "PREVIOUS_MONTH" },
];

const periodLabels = {
  CURRENT_DAY: "Current Day",
  TODAY: "Today",
  CURRENT_MONTH: "Current Month",
  PREVIOUS_MONTH: "Previous Month",
};

function Header({
  employeeData,
  dateInfo,
  tabValue,
  period,
  handlePeriodChange,
  handleSetTabValue,
  children,
  hasTabs,
}) {
  const showShortHours =
    employeeData.brand &&
    employeeData.brand.name.toLowerCase() === "cubix" &&
    (dateInfo.shortHours > 0 || dateInfo.shortWorklogHours > 0);

  return (
    // <MDBox position="relative">
    <Card
      sx={{
        position: "relative",
        pt: 2,
        pb: 0,
        px: 2,
      }}
    >
      <Grid container spacing={3} mb={2} alignItems="center">
        <Grid item>
          <MDBox display="flex" flexDirection="row" alignItems="center">
            <MDAvatar src={employeeData.image} alt="profile-image" size="xl" shadow="sm" />

            {/* </Grid>
        <Grid item> */}
            <MDBox
              height="100%"
              mt={0.5}
              ml={1.5}
              lineHeight={1}
              display="flex"
              flexDirection="column"
            >
              <MDTypography variant="h5" fontWeight="medium">
                {employeeData.userId} - {employeeData.name}
              </MDTypography>

              <MDBox display="flex" flexDirection="row">
                <MDTypography variant="button" color="text" fontWeight="regular">
                  Date:{" "}
                  {period === "CURRENT_DAY" || period === `TODAY`
                    ? formatDate(dateInfo.date, "ll")
                    : formatDate(dateInfo.date, "MMM YYYY")}
                </MDTypography>

                <MDTypography variant="button" color="text" fontWeight="regular" px={0.5}>
                  -
                </MDTypography>

                <BasicMenu
                  title={`${
                    period && period !== "" && period !== "CURRENT_DAY"
                      ? periodLabels[period]
                      : "Switch To"
                  } ▼`}
                  buttonProps={{
                    style: {
                      background: "none",
                      border: "none",
                      padding: 0,
                      minHeight: 0,
                      cursor: "pointer",
                      justifyContent: "flex-start",
                      // fontWeight: "regular",
                    },
                    variant: "text",
                    color: "info",
                  }}
                  options={periodOptions}
                  onOptionSelect={(value) => handlePeriodChange(value)}
                />
              </MDBox>

              <MDTypography variant="button" color="text" fontWeight="regular">
                {[
                  `Office: ${(dateInfo.officeTime / 3600).toFixed(2)}h`,
                  `Break: ${(dateInfo.breakTime / 3600).toFixed(2)}h`,
                  showShortHours && `Short: ${(dateInfo.shortHours / 3600).toFixed(2)}h`,
                ]
                  .filter(Boolean)
                  .join(" • ")}
              </MDTypography>

              {hasTabs && (
                <MDTypography variant="button" color="text" fontWeight="regular">
                  {[
                    `Jira: ${(dateInfo.worklogHours / 3600).toFixed(2)}h`,
                    showShortHours &&
                      `Jira Short: ${(dateInfo.shortWorklogHours / 3600).toFixed(2)}h`,
                  ]
                    .filter(Boolean)
                    .join(" • ")}
                </MDTypography>
              )}
            </MDBox>
          </MDBox>
        </Grid>
        {hasTabs && (
          <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs orientation={"horizontal"} value={tabValue} onChange={handleSetTabValue}>
                <Tab
                  label="Thumbs"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      fingerprint
                    </Icon>
                  }
                />
                <Tab
                  label="Jira Logs"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      devices
                    </Icon>
                  }
                />
              </Tabs>
            </AppBar>
          </Grid>
        )}
      </Grid>
      {children}
    </Card>
    // </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
